import { Link } from "react-router-dom";

export default function NTCtaSection() {
  return (
    <section className="bg-[#1B1F5E] py-5">
      <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div>
          <p className="font-rajdhani font-black text-white text-xl md:text-2xl uppercase">FAÇA AGORA SEU ORÇAMENTO</p>
          <p className="text-white/70 text-sm mt-0.5">Nossa equipe é especializada em entender a sua demanda. Fale conosco.</p>
        </div>
        <Link to="/contato" className="whitespace-nowrap bg-[#3FA7D6] hover:bg-[#2F4F8F] text-white font-bold px-8 py-3 rounded-md transition-colors cursor-pointer text-sm">
          Solicitar Orçamento
        </Link>
      </div>
    </section>
  );
}
